import { gatewayPhone } from "src/gateways/gatewayPhone";
import { CallFlowConfig } from "@components/virtual-receptionist/sms/types/update-company-config";
import { VoiceMessageSlot } from "../constants/voice-message-slots";

export const deleteVoiceMessageRecording = async (
    companyId: number,
    slotKey: VoiceMessageSlot,
): Promise<CallFlowConfig> => {
    const { data } = await gatewayPhone.delete(
        `company-call-config/${companyId}/voice-messages/${slotKey}/recording`,
    );

    return data;
};
